import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

export default function BreadCrump({ data }: any) {
    const { t } = useTranslation();
    const isRTL = t("dir") === "rtl";

    if (!data || data.length === 0) {
        return null;
    }

    return (
        <nav className="mb-6" aria-label="Breadcrumb" dir={t("dir")}>
            <motion.ol
                initial={{ opacity: 0, x: isRTL ? 20 : -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.3 }}
                className="flex items-center flex-wrap gap-2"
            >
                {data.map((i: any, index: number) => {
                    const isLast = index === data.length - 1;
                    const isFirst = index === 0;

                    return (
                        <li key={index} className="inline-flex items-center">
                            {i.url == null ? (
                                // Current page (last item)
                                <motion.span
                                    initial={{ opacity: 0 }}
                                    animate={{ opacity: 1 }}
                                    transition={{ delay: index * 0.1 }}
                                    className="inline-flex items-center gap-2 px-3 py-1.5 text-sm font-semibold text-gray-900 bg-blue-50 rounded-lg border border-blue-200"
                                    aria-current="page"
                                >
                                    {isFirst && (
                                        <svg className="w-4 h-4 text-blue-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                                        </svg>
                                    )}
                                    <span className="truncate max-w-[200px]">{t(i.name)}</span>
                                </motion.span>
                            ) : (
                                // Link item
                                <>
                                    <motion.div
                                        initial={{ opacity: 0 }}
                                        animate={{ opacity: 1 }}
                                        transition={{ delay: index * 0.1 }}
                                    >
                                        <Link
                                            to={i.url}
                                            className="inline-flex items-center gap-2 px-3 py-1.5 text-sm font-medium text-gray-600 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200 group"
                                        >
                                            {isFirst && (
                                                <svg className="w-4 h-4 text-gray-400 group-hover:text-blue-600 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
                                                </svg>
                                            )}
                                            <span className="truncate max-w-[200px]">{t(i.name)}</span>
                                        </Link>
                                    </motion.div>
                                    {!isLast && (
                                        <svg
                                            className={`shrink-0 w-4 h-4 text-gray-400 mx-1 ${isRTL ? 'rotate-180' : ''}`}
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                            xmlns="http://www.w3.org/2000/svg"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M9 5l7 7-7 7"
                                            />
                                        </svg>
                                    )}
                                </>
                            )}
                        </li>
                    );
                })}
            </motion.ol>
        </nav>
    );
}
